















































import { Mixins } from "vue-mixin-decorator";
import { Component } from "vue-property-decorator";
import { Action, Mutation, Getter } from "vuex-class";
import { IPartner } from "@/types/partner";
import { ICategory, ICategoryListRequest } from "@/types/category";
import GeneralMixin from "@/mixin";
import CostIndexList from "@/components/admin/list/CostIndexList.vue";

@Component({
  components: { CostIndexList }
})
export default class extends Mixins<GeneralMixin>(GeneralMixin) {
  @Action("partner/adminGet")
  public getPartner!: (id: number) => void;

  @Action("category/adminGetList")
  public getCategoryList!: (params: ICategoryListRequest) => boolean;

  @Getter("partner/single")
  public partner!: IPartner;

  @Getter("category/list")
  public categories!: ICategory[];

  @Mutation("partner/clear")
  public clear!: () => void;

  @Mutation("category/clear")
  public clearCategory!: () => void;

  @Mutation("cost_index/clear")
  public clearCostIndex!: () => void;

  // fields
  public partner_id = 0;

  public async created() {
    this.partner_id = Number(this.$route.params.partner_id);
    this.clear();
    this.clearCategory();

    await Promise.all([
      this.getPartner(this.partner_id),
      this.getCategoryList({ partner_id: this.partner_id })
    ]);
  }
}
